export default __webpack_public_path__ + "static/media/auditStep.a73d8d1d.png";